module.exports = __webpack_public_path__ + "img/info.8c3dd56a.svg";